export default __webpack_public_path__ + "static/media/play-fill.c0c277d2.svg";